// extracted by mini-css-extract-plugin
export default {"advertDetailServiceList":"c-m_hf","advertDetailServiceList__header":"c-m_hg","advertDetailServiceList__list":"c-m_hh"};